var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-breadcrumb" },
    [
      _vm._l(_vm.list, function(item) {
        return _c("span", [
          _c(
            "a",
            {
              staticClass: "c-link c-link--breadcrumb",
              attrs: { href: item[1] }
            },
            [_vm._v(_vm._s(item[0]))]
          ),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "6",
                height: "11",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [_c("path", { attrs: { d: "M1 1l4 4.5L1 10", stroke: "#444" } })]
          )
        ])
      }),
      _vm._v("\n  " + _vm._s(_vm._f("titleCase")(_vm.lastStep[0])) + "\n")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }